const ko = {
	login: '로그인',
	logout: '로그 아웃',
	signin: '로그인',
	signup: '가입하기',
	email: '이메일',
	emailAddr: '이메일 주소',
	password: '암호',
	rememberMe: '날 기억해',
	forgotYourPwd: '비밀번호를 잊어 버렸습니까?',
	signinFacebook: 'Facebook 로그인',
	signinGoogle: 'Google 로그인',
	dontAccount: '계정이 없습니까?',
	firstName: '이름',
	lastName: '성',
	confirmPwd: '비밀번호 확인',
	signup_msg: '지금 가입',
	digitX_user_agreement: 'DigitXchange 사용자 계약',
	privacy_policy: '개인 정보 정책',
	and: ' 과 ',
	cookies_policy: '쿠키 정책',
	have_account: '이미 계정이 있습니다',
	forgotPwd: '비밀번호 분실',
	recoverPwd: '비밀번호 복구',
	forgotPwd_msg: '위의 필드에 이메일을 넣으시면 따라야 할 지침이 포함 된 링크가 발송됩니다.',
	changePwd: '비밀번호 변경',
	oldPwd: '기존 비밀번호',
	newPwd: '새 비밀번호',
	confirmNewPwd: '새 암호를 확인합니다',
	user_account: '사용자 계정',
	change_pic: '사진 바꾸기',
	mobile_number: '휴대 전화 번호',
	country: '국가',
	update_settings: '설정 업데이트',
	company: '회사',
	aboutUs: '회사 소개',
	tos: 'TOS',
	copyright: '저작권',
	socialMedia: '소셜 미디어',
	forUpdates: '업데이트',
	footer_msg_1: '가입함으로써 당신은 수락합니다',
	terms: '서비스 약관',
	contactUs: '문의하기',
	yourEmail: '귀하의 이메일',
	required: '필수',
	yourMsg: '당신의 메시지',
	sent: '보냄',
	footer_msg_2: '모든 권리 보유',
	footer_msg_3: '모든 제품 이름, 상표 및 등록 상표는 해당 소유자의 재산입니다.',
	doom: '파멸 III',
	filter: '필터',
	add_asset: '자산 추가',
	request_game: '게임 요청',
	search_msg: '죄송하지만 검색어와 일치하는 것이 없습니다.',
	post: '우편',
	asset: '유산',
	create: '창조하다',
	character: '캐릭터',
	characters: '캐릭터',
	assets: '자산',
	profile: '프로필',
	game: '경기',
	games: '계략',
	currency: '통화',
	store: '저장',
	all_time: '모든 시간',
	this_month: '이번 달',
	trending: '동향',
	item_name: '상품명',
	view_item: '아이템보기',
	leaderboard: '리더 보드',
	posters: '포스터',
	chinese: '중국어',
	english: '영어',
	japanese: '일본어',
	korean: '한국어',
	german: '독일어',
	french: '프랑스어',
	spanish: '스페인어',
	italian: '이태리어',
	russian: '러시아어',
	portuguese: '포르투어',
	hindi: '힌디어',
	arabic: '아라비아어',
	buy: '구입',
	subscription: '신청',
	buy_subscription: '구독 구매',
	gift: '선물',
	xchange: 'Xchange',
	subscription_plan: '가입 계획',
	payment_options: '지불 옵션',
	cardholder_name: '카드 소지자 이름',
	submit_order: '주문을 제출',
	card_number: '카드 번호',
	cvv: 'CVV',
	expiration_date: '만료일',
	buyXchange: 'Xchange 구매',
	giftXchange: '선물 교환',
	or: '또는',
	select: '고르다',
	
	search: '검색',
	search_games: '게임 검색 ...',
	search_assets: '자산 검색 ...',
	platform: '플랫폼',
	total_posts: '총 게시물',
	total_comments: '총 댓글',
	total_characters: '총 문자',
	total_assets: '총 자산',
	xchange_currency: 'Xchange 통화',
	subscription_days_remaining: '남은 구독 일',
	total_asset_networth: '총 자산 순가',
	total_character_networth: '총 캐릭터 넷 워스',
	most_downloaded: '대부분 다운로드',
	recently_added: '최근에 추가',
	genre: '유형',
	my_library: '내 도서관',
	most_commented: '대부분의 댓글',
	most_recent: '가장 최근',
	nearing_addition: '니어링 추가',
	create_asset: '자산 생성',
	create_character: '캐릭터 만들기',
	asset_name: '자산 이름',
	asset_type: '자산 유형',
	rarity: '희박',
	enhancements: '향상',
	add: '더하다',
	currency_type: '통화 종류',
	price: '가격',
	description: '기술',
	upload_asset: '자산 업로드',
	preview_asset: '자산 미리보기',
	main_image: '메인 이미지',
	upload_video: '비디오 업로드',
	upload: '업로드',
	view_demo: '데모보기',
	character_name: '캐릭터 이름',
	character_type: '캐릭터 타입',
	upload_character: '캐릭터 업로드',
	preview_character: '미리보기 캐릭터',
	race: '경주',
	class: '수업',
	gender: '성별',
	level: '수평',
	showing: '전시',
	of: '의',
	results: '결과',
	featured_characters: '특집 캐릭터',
	url: 'URL',
	submit: '제출',
	real_world: '현실 세계',
	game_currency: '게임 통화',
	all: '모두',

	edit: '편집하다',
	save: '저장',
	agg_character_networth: '집계 된 문자 Networth',
	agg_time_played: '재생 시간',
	agg_asset_value: '집계 자산 가치',
	enter_character_creation_date: '캐릭터 생성 일 입력',
	in_game_currency: '게임 통화',
	real_world_value: '실제 가치',
	update_character: '캐릭터 업데이트',
	item_not_found: '아이템을 찾을 수 없습니다!',
	ripper: '찢는 사람',
	comments: '코멘트',
	add_comments: '의견 추가',
	new_suggested_price: '새로운 제안 가격',
	sort_by: '정렬 기준',
	reply: '댓글',
	asset_networth: '자산 넷 워스',
	join_date: '가입 날짜',
	report: '보고서',
	first: '먼저',
	last: '마지막',
	most_replies: '대부분의 답글',
	new_pricing_recommendations: '새로운 가격 권장 사항',
	xchange_amount: '교환 금액',
	username: '사용자 이름',
	send_gift: '선물을 보내다',
	message: '메시지',
	gift_text: '여기에서 메시지를 개인화하십시오',
	day: '일',
	days: '일',
	currency_converter: '환율 계산기',
	from: '에서',
	to: '에',
	in_game: '게임 내',
	real_life: '현실',
	cvc: 'CVC',
	card: '카드',
	per_month: '월간 (월 $3)',
	per_year: '연간 (연간 $30)',
	aboutUs_text: 'DigitXChange는 크라우드 소싱을 통해 가치있는 디지털 제품 및 서비스에 가치를 부여하는 것을 목표로하는 커뮤니티 중심 웹 사이트입니다. "내 캐릭터가 실제로 얼마나 가치가 있는지"또는 "다른 게임에서 다른 플레이어와의 공정한 거래가 궁금합니다."라는 질문을 한 경우 더 이상 답을 찾지 마십시오. 우리는 당신이 우리 사이트를 즐기고, 그룹 지식을 구축하는 데 참여하고, 열심히 얻은 전리품을 과시하고 궁극적으로 총 디지털 순 가치를 찾기를 기대합니다!',
	home: '홈페이지',
	all_time_characters: '모든 시간 문자',
	this_month_characters: '이번 달 캐릭터',
	trending_characters: '인기 캐릭터',
	all_time_posters: '모든 시간 포스터',
	this_month_posters: '이번 달 포스터',
	trending_posters: '트렌드 포스터',
	
};

export default ko;


// WEBPACK FOOTER //
// ./src/translations/ko.js